
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/agb",
      function () {
        return require("private-next-pages/legal/agb.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/agb"])
      });
    }
  